(function () {
  angular.module('kareo.ui.shared.directives.krome-menu', [])
    .directive('kromeMenu', kromeMenuDirective);

  function kromeMenuDirective() {
    return {
      restrict: 'A',
      link
    };
    function link(scope, element, attrs) {
      var show = false;

      if (attrs.kromeMenu) {
        scope.$watch(attrs.kromeMenu, (value) => {
          if (value) {
            show = value.show;
          }
          element.toggleClass('ng-hide', !show);
        });
      }

      element.on('mouseenter', mouseEnter);
      element.on('mouseleave', mouseLeave);

      function mouseEnter() {
        hoverChange(true);
      }

      function mouseLeave() {
        hoverChange(false);
      }
      function hoverChange(hovered) {
        element.toggleClass('is-open', hovered);
      }
    }
  }
})();
